import { useEffect, useState } from 'react';
import axios from 'axios';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useDropzone } from 'react-dropzone';

function App() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [htmlContent, setHtmlContent] = useState('');
  const [error, setError] = useState('');

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    handleWordUpload({ target: { files: [file] } });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  // =====================================================
  // FUNCIÓN PARA EXPORTAR HTML → PDF
  // =====================================================
  const handleExportPDF = async () => {
    try {
      setLoading(true);
      setProgress(0);

      const response = await axios.post(
        "https://api.cruzespinosa.com/api/pdf",
        { html: htmlContent },
        { responseType: "blob" }
      );

      // Descargar PDF automáticamente
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(pdfBlob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "documento.pdf";
      a.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      setError("Error al generar PDF.");
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // SUBIR WORD → HTML (tu función original)
  // =====================================================
const handleWordUpload = async (e) => {
  const file = e.target.files[0];
  
  const data = new FormData();
  data.append("doc", file);  // <=== IMPORTANTE

  setLoading(true);
  setProgress(0);

  try {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.cruzespinosa.com/api/upload",
      headers: { 
        // axios AUTOMÁTICAMENTE pone multipart/form-data con boundary
        "Content-Type": "multipart/form-data"
      },
      data: data,
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setProgress(percentage);
      },
    };

    const response = await axios.request(config);
    setHtmlContent(response.data.html || "");

  } catch (error) {
    console.error(error);
    setError("Hubo un error al convertir el archivo.");
  } finally {
    setLoading(false);
  }
};


  return (
    <div style={{ padding: 20 }}>
      <h1>Editor HTML con convertidor de Word/Excel a HTML y PDF</h1>

      {/* Upload Dropzone */}
      <div
        {...getRootProps()}
        style={{
          border: "2px dashed #999",
          padding: "30px",
          textAlign: "center",
          marginBottom: "20px",
          backgroundColor: isDragActive ? "#f0f8ff" : "#fafafa",
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} accept="*" />
        {isDragActive ? (
          <p>Suelta el archivo aquí...</p>
        ) : (
          <p>Arrastra un archivo aquí, o haz clic para seleccionarlo</p>
        )}
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* Barra de progreso */}
      {loading ? (
        <>
          <p>Procesando archivo...</p>
          <div style={{ marginTop: 10 }}>
            <progress value={progress} max="100" style={{ width: "100%", height: "20px" }} />
          </div>
        </>
      ) : (
        <>
          {/* === CKEditor === */}
          <div style={{ marginTop: 20 }}>
            <CKEditor
              editor={ClassicEditor}
              data={htmlContent}
              onChange={(event, editor) => {
                setHtmlContent(editor.getData());
              }}
            />
          </div>

          {/* === BOTÓN PARA EXPORTAR PDF === */}
          {htmlContent && 
          <button
            onClick={handleExportPDF}
            style={{
              marginTop: 20,
              padding: "12px 25px",
              backgroundColor: "#0070f3",
              color: "#fff",
              border: "none",
              borderRadius: 5,
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            📄 Exportar a PDF
          </button>
          }
        </>
      )}
    </div>
  );
}

export default App;
